export default __webpack_public_path__ + "static/media/Scott Wiener.34a0596e.jpg";